import { render } from "./CaseStudiesCarousel.vue?vue&type=template&id=2c8ac84a&scoped=true"
import script from "./CaseStudiesCarousel.vue?vue&type=script&lang=js"
export * from "./CaseStudiesCarousel.vue?vue&type=script&lang=js"

import "./CaseStudiesCarousel.vue?vue&type=style&index=0&id=2c8ac84a&scoped=true&lang=scss"

import exportComponent from "/Users/leopons/Desktop/1_bm_dev/bubblemaps-showcase/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8ac84a"]])

export default __exports__